import { StateProvider, StateParams } from "@uirouter/angularjs";
import { ServerUtility } from "../records/server/serverUtility";
import { IRowCommandEventArgs } from "../records/grids/controller";
import { vsComponentName as contractInstanceComponentName } from "./views/Instances";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../records/views/recordGridView";
import { vsObjectName as contractInstanceName } from "./shared/configs/contractInstance";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider.state("main.contract", {
    url: "contract",
    component: contractInstanceComponentName,
    resolve: {
      gridConfiguration: [
        RecordGridViewServiceName,
        (recordGridViewService: RecordGridViewService) =>
          recordGridViewService.getGridConfiguration(contractInstanceName),
      ],
    },
  });
}
routeConfig.$inject = ["$stateProvider"];

function lockContract(
  serverUtility: ServerUtility,
  args: IRowCommandEventArgs<any>
) {
  serverUtility
    .sendApiRequest({
      method: "PATCH",
      url: `/api/contract/contract/lock`,
      data: { Id: args.data.Id, Locked: !args.data.Locked },
    })
    .then((response) => {
      if (response) {
        args.data.Locked = !args.data.Locked;
      }
    });
}
